import type { Language } from '../types';

/** The language the visitor last chose, or Turkish, the site default, if they never chose one. */
export const savedLanguage = (): Language => {
  const saved = localStorage.getItem('delay24_language');
  return saved === 'tr' || saved === 'en' ? saved : 'tr';
};
